// extracted by mini-css-extract-plugin
export default {"main-content-wrapper":"Video_main-content-wrapper__7tf3D","school":"Video_school__heIEI","main":"Video_main__CJe7T","h2":"Video_h2__5Un+b","h3":"Video_h3__2lFyk"};